import React from 'react';

import Icon from '../Icon/Icon';

const BatteryBlueIcon = (props) => {
    const {percentage, ...rest} = props;

    let fill;

    if (percentage < 25) {
        fill = 'var(--color-error)';
    } else if (percentage < 50) {
        fill = 'var(--color-sandy)';
    } else {
        fill = 'var(--color-tertiary)';
    }

    return (
        <Icon width='32' height='32' fill='none' {...rest}>
            <defs>
                <linearGradient id='gradient' x1='0%' y1='0%' x2='100%' y2='0%'>
                    <stop offset='0%' stopColor={fill} />
                    <stop offset={`${percentage}%`} stopColor={fill} />
                    <stop offset={`${percentage}%`} stopOpacity={0} />
                    <stop offset='100%' stopOpacity={0} />
                </linearGradient>
            </defs>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M 8.776 13.142 L 20.776 13.142 C 21.042 13.142 21.297 13.249 21.484 13.441 C 21.671 13.632 21.776 13.892 21.776 14.163 L 21.776 17.837 C 21.776 18.108 21.671 18.367 21.484 18.559 C 21.297 18.75 21.042 18.858 20.776 18.858 L 8.776 18.858 C 8.51 18.858 8.255 18.75 8.068 18.559 C 7.881 18.367 7.776 18.108 7.776 17.837 L 7.776 14.163 C 7.776 13.892 7.881 13.632 8.068 13.441 C 8.255 13.249 8.51 13.142 8.776 13.142 Z'
                fill='url("#gradient")'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.5794 10.6416C22.1831 10.6416 22.7303 10.8988 23.126 11.3142C23.5216 11.7296 23.7666 12.3043 23.7666 12.9381V19.0622C23.7666 19.696 23.5216 20.2707 23.126 20.6861C22.7303 21.1015 22.1831 21.3587 21.5794 21.3587H7.97037C7.68309 21.3591 7.39857 21.2999 7.13316 21.1844C6.86775 21.069 6.62668 20.8996 6.4238 20.6861C6.2204 20.4731 6.0591 20.2199 5.94917 19.9413C5.83923 19.6626 5.78283 19.3638 5.7832 19.0622V12.9381C5.7832 12.3043 6.02817 11.7296 6.4238 11.3142C6.81944 10.8988 7.36671 10.6416 7.97037 10.6416H21.5794Z'
                stroke='#34303D'
                strokeWidth='1.33964'
            />
            <path d='M27.2178 12.4287V19.5734' stroke='#34303D' strokeWidth='1.33964' />
        </Icon>
    );
};

export default BatteryBlueIcon;
